/**
 * 実行状態を視覚的に表示するインジケーター
 */
export class StatusIndicator {
  private container: HTMLElement
  private statusElement: HTMLElement
  
  constructor() {
    this.container = document.createElement('div')
    this.container.className = 'status-indicator'
    
    this.statusElement = document.createElement('div')
    this.statusElement.className = 'status-indicator__content'
    this.container.appendChild(this.statusElement)
    
    // ヘッダーに追加
    const header = document.querySelector('.header')
    if (header) {
      header.appendChild(this.container)
    }
    
    this.setupStyles()
    this.updateStatus('idle')
  }
  
  /**
   * スタイルを設定
   */
  private setupStyles(): void {
    const style = document.createElement('style')
    style.textContent = `
      .status-indicator {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
      }
      
      .status-indicator__content {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 1rem;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 2rem;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        font-size: 0.875rem;
        font-weight: 500;
        opacity: 0;
        transform: scale(0.9);
        transition: all 0.3s ease;
      }
      
      .status-indicator__content.visible {
        opacity: 1;
        transform: scale(1);
      }
      
      .status-indicator__icon {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: currentColor;
        position: relative;
      }
      
      /* 実行中のアニメーション */
      .status-indicator__content.running .status-indicator__icon {
        animation: statusPulse 1s ease-in-out infinite;
      }
      
      @keyframes statusPulse {
        0%, 100% {
          transform: scale(1);
          opacity: 1;
        }
        50% {
          transform: scale(1.2);
          opacity: 0.7;
        }
      }
      
      /* 各状態のカラー */
      .status-indicator__content.idle {
        color: #6b7280;
      }
      
      .status-indicator__content.running {
        color: var(--primary-color);
      }
      
      .status-indicator__content.paused {
        color: #f59e0b;
      }
      
      .status-indicator__content.completed {
        color: var(--secondary-color);
      }
      
      .status-indicator__content.error {
        color: var(--error-color);
      }
      
      /* ステップカウンター */
      .status-indicator__steps {
        font-size: 0.75rem;
        color: #6b7280;
        margin-left: 0.5rem;
      }
      
      @media (max-width: 768px) {
        .status-indicator {
          position: static;
          transform: none;
          margin-top: 0.5rem;
        }
        
        .status-indicator__content {
          font-size: 0.75rem;
          padding: 0.375rem 0.75rem;
        }
      }
    `
    document.head.appendChild(style)
  }
  
  /**
   * ステータスを更新
   */
  updateStatus(state: 'idle' | 'running' | 'paused' | 'completed' | 'error', stepCount?: number): void {
    // 既存のクラスを削除
    this.statusElement.className = 'status-indicator__content'
    
    // 新しい状態を適用
    this.statusElement.classList.add(state)
    
    let html = '<span class="status-indicator__icon"></span>'
    
    switch (state) {
      case 'idle':
        html += '<span>待機中</span>'
        break
      case 'running':
        html += '<span>実行中</span>'
        if (stepCount !== undefined) {
          html += `<span class="status-indicator__steps">${stepCount} ステップ</span>`
        }
        break
      case 'paused':
        html += '<span>一時停止</span>'
        if (stepCount !== undefined) {
          html += `<span class="status-indicator__steps">${stepCount} ステップ</span>`
        }
        break
      case 'completed':
        html += '<span>実行完了</span>'
        if (stepCount !== undefined) {
          html += `<span class="status-indicator__steps">合計 ${stepCount} ステップ</span>`
        }
        break
      case 'error':
        html += '<span>エラー</span>'
        break
    }
    
    this.statusElement.innerHTML = html
    
    // 表示/非表示のアニメーション
    if (state === 'idle') {
      setTimeout(() => {
        this.statusElement.classList.remove('visible')
      }, 100)
    } else {
      setTimeout(() => {
        this.statusElement.classList.add('visible')
      }, 100)
    }
    
    // 完了時は3秒後に非表示
    if (state === 'completed') {
      setTimeout(() => {
        this.statusElement.classList.remove('visible')
      }, 3000)
    }
  }
}